import client from "../client";

export const baseUrlPath = "dental_identification";

export const getAllDentalIndentificationProjects = async ({
  search = "",
  status = "",
  ownership = "",
}) => {
  return await client.get(
    `/${baseUrlPath}/projects?search=${search}&status=${status}&ownership=${ownership}`
  );
};

export const updateProjectStatus = async ({ payload }) => {
  return await client.put(`/${baseUrlPath}/projects/status`, payload);
};

export const createDentalIndentificationProject = async ({ payload }) => {
  return await client.post(`/${baseUrlPath}/projects`, payload);
};

export const findDentalIndentificationProject = async ({ id }) => {
  return await client.get(`/${baseUrlPath}/projects/${id}`);
};

export const createNewAM_Or_PmCaseForCurrentProject = async ({
  type,
  payload,
}) => {
  return await client.post(`${baseUrlPath}/cases/${type}`, payload);
};
export const deleteAM_Or_PmCaseForCurrentProject = async ({ id }) => {
  return await client.delete(`${baseUrlPath}/cases/${id}`);
};

export const getAllDropdownsData = async () => {
  return await client.get("/dropdowns/subject_registration");
};
export const getAllCountries = async () => {
  return await client.get("/countries");
};
export const getExaminarsSpecialties = async () => {
  return await client.get("/dropdowns/examiner_registration");
};

export const getExaminars = async ({ search }) => {
  return await client.get(`/contacts/examiners?search=${search}`);
};
export const getSiteData = async () => {
  return await client.get(`/site-data`);
};

export const onAddExaminarToProject = async ({ payload }) => {
  return await client.post(`${baseUrlPath}/collaborators`, payload);
};
export const onDeleteExaminarFromProject = async ({ payload }) => {
  return await client.delete(`${baseUrlPath}/collaborators`, { data: payload });
};

export const getDentalIndentificationMetaData = async () => {
  return await client.get(`${baseUrlPath}/meta`);
};

export const addDentalRecordForCase = async ({ payload }) => {
  return await client.post(`${baseUrlPath}/cases/records`, payload);
};

export const getCaseSimulationsByCaseId = async ({ id }) => {
  return await client.get(`${baseUrlPath}/simulations/by_case/${id}`);
};
export const getCaseSimulationDetailsByCaseId = async ({ id }) => {
  return await client.get(`${baseUrlPath}/simulations/details/${id}`);
};

export const getDashboardData = async () => {
  return await client.get(`${baseUrlPath}/dashboard`);
};

export const deleteProject = async ({ projectId }) => {
  return await client.delete(`${baseUrlPath}/projects/${projectId}`);
};
